import { createSelector } from '@reduxjs/toolkit';

import { selectImprovementsEntities } from './propertyDataSelectors/improvementsSelectors.ts';

/**
 * Whether one or more of the (non-subject) comparables has a Partial or Finished
 * basement. Used to require a "Basement Area Disclosure" note (captured via
 * `BasementAreaDisclosureModal`) explaining how below-grade square footage is being accounted
 * for when it isn't separated out in the MLS/tax records, before the appraiser can leave the
 * Comparables page.
 */
export const selectHasPartialOrFinishedBasementComp = createSelector(
  [selectImprovementsEntities],
  (improvementsEntities) =>
    Object.entries(improvementsEntities).some(
      ([id, improvements]) =>
        id !== 'subject' &&
        improvements?.basement?.hasFeature === true &&
        (improvements.basement.type === 'partial' || improvements.basement.type === 'finished'),
    ),
);
